import { useAppSelector } from 'app/hooks';
import { useAnalyzer } from 'features/analyzers/api/getAnalyzer';
import { AnalyzerMode } from 'features/analyzers/types';
import { useSnapshot } from 'features/snapshots/api/getSnapshot';
import { selectTraceDataBySnapshotId } from 'features/spectrasWebSocketServer/spectrasWebSocketServerSlice';
import { parseTraceFromBuffer } from 'utils/traceUtils';

interface Props {
  snapshotId: number;
  analyzerId: number;
  staticTrace: number[] | null | undefined;
}

export const useTraceData = ({
  snapshotId,
  analyzerId,
  staticTrace,
}: Props): number[] => {
  const { data: analyzer } = useAnalyzer({ analyzerId });
  const { data: snapshot } = useSnapshot({ snapshotId });

  //Dont grab last trace if analyzer is live and doesn't have a last trace
  const lastTrace =
    analyzer?.mode === AnalyzerMode.LIVE && !snapshot?.last_trace
      ? undefined
      : snapshot?.last_trace;

  const liveTrace = useAppSelector((state) =>
    selectTraceDataBySnapshotId(state, snapshotId)
  );
  if (staticTrace) return staticTrace;
  if (liveTrace) return liveTrace;
  if (lastTrace) return parseTraceFromBuffer(lastTrace);

  return [];
};
